import {FC, useEffect, useMemo, useState} from "react";
import {TitleAndContentLayout} from "../components/TitleAndContentLayout";
import {TenantList} from "../components/TenantList";
import {TenantResource} from "../enums/TenantResource";
import {ITenantColumn} from "../components/OnixElements";
import {SupportStatusEnum, SupportTicket, SupportTicketDto} from "../API";
import {MakeTenantColumns} from "../helpers/MakeTenantColumns";
import {useTranslation} from "react-i18next";
import {DefaultButton, PrimaryButton, Stack, Text} from "@fluentui/react";
import {OpenSupportTicket} from "../components/LinkTo";
import {useNavigate} from "react-router-dom";
import {AppRoute} from "../AppRoutes";
import axios from "axios";
import {theme} from "../index";

const PantheonUpgradeLogsPage: FC = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();
    const [clientsAtVersion, setClientsAtVersion] = useState<{ [key: number]: number }>({});

    const totalClients = useMemo(() => {
        return Object.values(clientsAtVersion).reduce((acc, val) => acc + val, 0);
    }, [clientsAtVersion]);

    useEffect(() => {
        axios.post("PantheonTHeSetSubjWithAcSubjType/CountPerVersion")
            .then(({data}) => {
                setClientsAtVersion(data);
            });
    }, []);

    const columns = useMemo<ITenantColumn<SupportTicketDto>[]>(() => MakeTenantColumns({
        pantheonVersion: {
            render: (row) => {
                const {pantheonVersionFormatted, pantheonVersion} = row;

                if (pantheonVersionFormatted) {
                    const majorVersion = pantheonVersionFormatted.split(".")[0];
                    const minorVersion = pantheonVersionFormatted.split(".")[1];

                    return <Stack horizontal>
                        <Text variant={"xLarge"}>{majorVersion}</Text>
                        <Text style={{color: "lightgray"}} variant={"xLarge"}>&nbsp;{"."}&nbsp;</Text>
                        <Text variant={"xLarge"}>{minorVersion}</Text>
                        <Text variant={"xLarge"}>&nbsp;</Text>
                        <Text variant={"xLarge"}>&nbsp;</Text>
                        <Text variant={"xLarge"}>&nbsp;</Text>
                        <Text style={{color: "gray"}} variant={"xLarge"}>{pantheonVersion}</Text>
                    </Stack>;
                } else if (pantheonVersion) {
                    return <Text variant={"xLarge"}>{pantheonVersion}</Text>;
                } else {
                    return <Text variant={"xLarge"}>N/A</Text>;
                }
            }
        },
        companyCountAtVersion: {
            render: (row) => {
                const {pantheonVersion} = row;
                
                const percentageOfTotal = Math.round((clientsAtVersion[+(pantheonVersion?.trim() ?? 0)] / totalClients) * 100);

                return <Stack horizontal>
                    <div style={{width: `${percentageOfTotal}%`,
                        background: theme.palette.themeLight,
                        position: "absolute",
                        left: 0, 
                        height: 24,
                        margin: 0,
                        padding: 0,
                        zIndex: 10,
                    }}/>
                    <Text style={{zIndex: 100}} variant={"xLarge"}>{clientsAtVersion[+(pantheonVersion?.trim() ?? 0)]}</Text>
                </Stack>;
            }
        },
        logOverview: {
            render: (row) => <DefaultButton iconProps={{
                iconName: "OpenInNewWindow"
            }} onClick={() => navigate(AppRoute.EDIT_SUPPORT_TICKET(row.id))}>Otvori
                pregled zapisnika</DefaultButton>,
        }
    }, t, 300), [t, clientsAtVersion]);

    return <TitleAndContentLayout title={"pantheon-upgrade-logs"} pad>
        <TenantList resource={TenantResource.SupportTicketCRUD}
                    baseDto={{}}
                    key={Object.keys(clientsAtVersion).length}
                    columns={columns}
                    allowedActions={[]}
                    allowSearching={true}
                    query={{
                        status: {
                            Equals: SupportStatusEnum.PantheonUpgrade,
                        },
                        pantheonVersion: {
                            Truthy: true
                        }
                    }}
                    disablePaging={true}
                    queryIsRequired={true}
                    orderBy={"pantheonVersion"}
                    orderDescending={true}/>
    </TitleAndContentLayout>
}

export default PantheonUpgradeLogsPage;